import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant='h3'>{children}</Typography>
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

export default function GenerateInvoiceModal({
  open,
  totalOrders,
  currentOrderIndex,
}) {
  return (
    <Dialog disableBackdropClick={true} open={open}>
      <DialogTitle>Generating Printify Invoice</DialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>
          Checking Order: {currentOrderIndex}/{totalOrders}
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
